export const validatePasswordSecurity = (password) => {
  if (password.length < 12)
    return 'Das Passwort muss mindestens 12 Zeichen lang sein.';
  if (!/[A-Z]/.test(password))
    return 'Das Passwort muss mindestens einen Großbuchstaben enthalten.';
  if (!/[a-z]/.test(password))
    return 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten.';
  if (!/[0-9]/.test(password))
    return 'Das Passwort muss mindestens eine Zahl enthalten.';
  if (!/[!@#$%^&*)(+=._-]/.test(password))
    return 'Das Passwort muss mindestens ein Sonderzeichen enthalten.';
  return null;
};
